export function extractRemainder(short: string, long: string) {
  if (long.startsWith(short)) {
    return long.substring(short.length);
  } else {
    return '';
  }
}
